import { NotificationType } from '@shared/models';
import { appConfig } from '@app/app.config';

export const NotificationLicenses = {
  [NotificationType.DUPLICATE]: appConfig.privileges.notification.duplicates,
  [NotificationType.INVITED_APPLIED]: appConfig.privileges.notification.inviteToApply,
  [NotificationType.HIRING_MANAGER]: appConfig.privileges.notification.hiringManagerFlow,
  [NotificationType.REFERRAL]: appConfig.privileges.notification.referralExtended,
};

export type NotificationLicenseType = typeof NotificationLicenses;
